export default __webpack_public_path__ + "static/media/51.7e22a288.png";